import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import FancyLink from "~/components/parts/FancyLink";
import { posthogEventCoursesHomeClicked } from "~/utils/posthog/courses";

const CoursesHomeLink = ({
  className,
  href = "/view-courses.php",
  posthogTriggerId,
}) => {
  const handleClick = (e) => {
    e.preventDefault();
    if (posthogTriggerId) {
      posthogEventCoursesHomeClicked({
        triggerId: posthogTriggerId,
      });
    }
    window.location = href;
  };

  return (
    <FancyLink
      {...{ className, href, title: "Go to courses home page" }}
      onClick={handleClick}
    >
      <div className="flex flex-none justify-center transition-transform duration-500 group-hover:scale-110">
        <HomeIcon sx={{ fontSize: "16px" }} />
      </div>
      <span>Courses</span>
    </FancyLink>
  );
};

export default CoursesHomeLink;
